// extracted by mini-css-extract-plugin
export default {"wrapper":"yt","noPadding":"zt","flavor_wrapper":"At","flavor_button":"Bt","vert":"Ct","itemContent":"Et","itemName":"Ft","blue":"Gt","out_of_stock":"Ht","newFlavorBadge":"It","fullWidth":"Jt","flavor_button_selected":"Kt","black":"Lt","attribute_wrapper":"Mt","toggle_wrapper":"Nt"};
    if(module.hot) {
      // 1714654884005
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  